/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import Header from "./header"
import "./layout.css"
import '../components/css/reset.css'
import { css } from "@emotion/core"
import Color from "../components/style/Color"
import {min} from "../components/style/Base"
import Size from "../components/style/Size"


const wrap = css`
  width: 100%;
  padding:0 16px;
  ${min[1]}{
    min-height: 100vh;
    margin: 0 auto;
    max-Width: 960px;
    width:100%;
    padding-bottom:44px;
  }
`
const footer = css`
  width:100%;
  background-color: ${Color.MainColor};
  color:${Color.White};
  text-align:center;
  padding: 32px 16px;
  a{
    color:${Color.White};
    text-decoration:none;
  }
`

const name = css`
  margin-top: 16px;
  font-size:${Size.textXS};
`

const link =css `
  margin-top: 4px;
  color: ${Color.White};
  font-size:${Size.textS};
  a {
    color: ${Color.White};
    text-decoration:none;
  }
`

const linkBox = css`
  display: flex;
  justify-content: space-around;
  ${min[1]}{
    margin: 0 auto;
    max-width: 800px;
    width: 100%;
  }
`


const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      <Header siteTitle={data.site.siteMetadata.title} />
      <div css={wrap}>
        <main>{children}</main>
      </div>
      <footer css={footer}>
        <div css={linkBox}>
            <a href="https://min-study.com/kiyaku" css={link}>利用規約</a>
            <a href="https://min-study.com/policy" css={link}>プライバシーポリシー</a>
            <a href="https://min-study.com/contact" css={link}>お問い合わせ</a>
          </div>
        <p css={name}>
          © {new Date().getFullYear()}
          {` `}
          <a href="https://twitter.com/minnano_study">@minnao_study</a>
          </p>
        </footer>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
